import { css, html, LitElement, nothing } from 'lit';
import './d-login.js';
import { customElement, property } from 'lit/decorators.js';
import { t } from 'src/i18n';

/**
 *
 * @fires request-login submit login request. (fra d-login)
 * @fires request-password submit password request (fra d-login)
 *
 * STATUS OK
 */
@customElement('d-signin')
export class DSignin extends LitElement {
  static readonly styles = css`
    :host {
      display: block;
      background: var(--outskirts-background-color);
      padding-top: 0px;
    }

    .expired-session-message {
      max-width: 400px;
      margin: 20px auto;
      padding: 16px 20px;
      background-color: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 8px;
      color: white;
      text-align: center;
      font-family: var(--mainSans);
      font-size: 15px;
      line-height: 1.5;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .expired-session-message::before {
      content: '⏱';
      font-size: 24px;
      display: block;
      margin-bottom: 8px;
    }
  `;
  /**
   * Vis feilmelding for innlogging feilet.
   */
  @property({ type: Boolean })
  loginFailed = false;
  @property({ type: Boolean })
  showExpired = false;
  /**
   * The mode. Use ??? for linking ssecure login methods
   */
  @property({ type: String })
  mode = '';

  /**
   * The location search. Set this to value of `window.location.search` when mode is `link`.
   */
  @property({ type: String })
  locationSearch = '';

  render() {
    return html`
      ${this.showExpired ? html`<div class="expired-session-message">${t('login.sessionExpired')}</div>` : nothing}
      <d-login .loginFailed=${this.loginFailed} .mode=${this.mode} .locationSearch=${this.locationSearch}
        ><slot slot="usernameInput" name="usernameInput"></slot> <slot slot="passwordInput" name="passwordInput"></slot
      ></d-login>
    `;
  }

  protected willUpdate() {
    this.checkUrlParameters();
  }

  /**
   * Checks for URL parameters and handles them appropriately
   */
  private checkUrlParameters() {
    const query = location.search.slice(1);
    const params = new URLSearchParams(query);

    // Check for showExpired parameter
    if (params.has('showExpired')) {
      this.showExpired = true;
      history.replaceState({}, '', location.protocol + '//' + location.host + location.pathname);
      setTimeout(() => {
        this.showExpired = false;
      }, 30000);
    }

    // Only set locationSearch from URL if not already set by parent component (e.g., in link mode)
    // This ensures we don't override the locationSearch passed from d-app-core in link mode
    if (!this.locationSearch) {
      this.locationSearch = location.search;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-signin': DSignin;
  }
}
